import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";

export const fetchcleaner = createAsyncThunk('fetchcleaner', async (params:any)=>{
    try{
    const queryParams = new URLSearchParams()
    queryParams.append('id', params?.id)
const res = await getCleaner(queryParams)
if(res?.success===true){
    return res?.data
}
else{
    return null
}
    }
    catch(e:any){

    }
    
})

interface CleanerState {
    data:any,
    isLoading: boolean;
    isError: boolean
}    
const initialState:CleanerState =  {
    isLoading: false,
    data: null,
    isError: false
}
const CleanerSlice = createSlice({
    name:'cleaner',
    initialState,
    extraReducers:(builder)=>{

   builder.addCase(fetchcleaner.pending, (state, action)=>{
                   state.isLoading = true
           })
                       builder.addCase(fetchcleaner.fulfilled, (state, action) => {
   
                           
                           state.data = action.payload;
                       })
                       builder.addCase(fetchcleaner.rejected, (state, action) => {
                          state.isError = true;
           
                       });
       },
       reducers:undefined
})
export default CleanerSlice.reducer